"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Text = _interopRequireDefault(require("../Text"));
var _Theme = _interopRequireDefault(require("../Theme"));
var _constant = require("../constant");
var _constant2 = require("./constant");
var _score = _interopRequireDefault(require("./score.proptypes"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/* eslint-disable react/prop-types */

var ScoreBox = _styledComponents.default.div.withConfig({
  displayName: "Score__ScoreBox",
  componentId: "sc-17yss0-0"
})(["position:relative;display:block;justify-content:center;max-width:", ";", ""], function (_ref) {
  var maxWidth = _ref.maxWidth;
  return maxWidth;
}, function (_ref2) {
  var marginBottom = _ref2.marginBottom,
    theme = _ref2.theme;
  return marginBottom && (0, _styledComponents.css)(["margin-bottom:", ";"], theme.space[marginBottom]);
});
var ScoreWrapper = _styledComponents.default.div.withConfig({
  displayName: "Score__ScoreWrapper",
  componentId: "sc-17yss0-1"
})(["line-height:", ";outline:none;margin:6px;width:", ";height:", ";font-family:", ";border-radius:100%;cursor:pointer;font-size:", ";white-space:nowrap;vertical-align:middle;display:inline-block;border:1px solid ", ";color:", ";text-align:center;font-size:", ";background-color:", ";&:hover{background-color:", ";color:", ";}&:active{background-color:", ";color:", ";}"], function (_ref3) {
  var scoreLineHeight = _ref3.scoreLineHeight;
  return scoreLineHeight;
}, function (_ref4) {
  var scoreWidth = _ref4.scoreWidth;
  return scoreWidth;
}, function (_ref5) {
  var scoreHeight = _ref5.scoreHeight;
  return scoreHeight;
}, function (props) {
  return props.theme.fontFamily.default;
}, function (props) {
  return props.theme.fontSize.normal;
}, function (_ref6) {
  var borderColor = _ref6.borderColor,
    theme = _ref6.theme;
  return theme.colors[borderColor];
}, function (props) {
  return props.isActive ? props.theme.colors.default : props.theme.colors.neutral;
}, function (props) {
  return props.isActive && props.theme.fontSize.medium;
}, function (_ref7) {
  var color = _ref7.color,
    theme = _ref7.theme,
    isActive = _ref7.isActive;
  return isActive ? theme.colors[color] : theme.colors.default;
}, function (_ref8) {
  var color = _ref8.color,
    theme = _ref8.theme;
  return theme.colors[color];
}, function (props) {
  return props.theme.colors.default;
}, function (_ref9) {
  var color = _ref9.color,
    theme = _ref9.theme;
  return theme.colors[color];
}, function (props) {
  return props.theme.colors.default;
});
var ScoreDescription = (0, _styledComponents.default)(_Text.default).withConfig({
  displayName: "Score__ScoreDescription",
  componentId: "sc-17yss0-2"
})(["display:flex;justify-content:space-between;color:", ";font-size:", ";"], function (props) {
  return props.theme.colors.greyDark;
}, function (props) {
  return props.theme.fontSize.XSmall;
});
var SingleScoreBox = function SingleScoreBox(props) {
  var value = props.value,
    className = props.className,
    getScore = props.getScore,
    color = props.color,
    isActive = props.isActive,
    id = props.id,
    tabIndex = props.tabIndex,
    scoreHeight = props.scoreHeight,
    scoreWidth = props.scoreWidth,
    scoreLineHeight = props.scoreLineHeight,
    borderColor = props.borderColor;
  return /*#__PURE__*/_react.default.createElement(ScoreWrapper, {
    id: id,
    tabIndex: tabIndex,
    isActive: isActive,
    className: className,
    color: color,
    onClick: function onClick() {
      return getScore(value);
    },
    onKeyPress: function onKeyPress() {
      return getScore(value);
    },
    scoreHeight: scoreHeight,
    scoreWidth: scoreWidth,
    scoreLineHeight: scoreLineHeight,
    borderColor: borderColor || color
  }, value);
};
var ScoreLineWrapper = _styledComponents.default.div.withConfig({
  displayName: "Score__ScoreLineWrapper",
  componentId: "sc-17yss0-3"
})(["display:flex;flex-wrap:wrap;justify-content:center;", ";"], function (_ref10) {
  var viewport = _ref10.viewport;
  return viewport === _constant.DEVICE_TYPE.MOBILE && (0, _styledComponents.css)(["justify-content:center;"]);
});
var Score = function Score(props) {
  var theme = props.theme,
    viewport = props.viewport,
    isScoringTypeBiased = props.isScoringTypeBiased,
    marginBottom = props.marginBottom,
    scoreCallback = props.scoreCallback,
    poorTag = props.poorTag,
    excellentTag = props.excellentTag,
    accessible = props.accessible,
    defaultScore = props.defaultScore,
    minScore = props.minScore,
    maxScore = props.maxScore,
    scoreHeight = props.scoreHeight,
    scoreWidth = props.scoreWidth,
    scoreLineHeight = props.scoreLineHeight,
    scoreColor = props.scoreColor,
    keyIndex = props.keyIndex;
  var _React$useState = _react.default.useState(defaultScore),
    _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
    ScoreSelected = _React$useState2[0],
    setScoreSelected = _React$useState2[1];
  var tabIndex = !accessible ? '-1' : '0';
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  var getScore = function getScore(arg) {
    setScoreSelected(arg === ScoreSelected ? null : arg);
  };
  _react.default.useEffect(function () {
    if (scoreCallback && ScoreSelected !== null && ScoreSelected !== undefined) {
      scoreCallback(ScoreSelected, keyIndex);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ScoreSelected]);
  var getScoreDescription = function getScoreDescription() {
    return /*#__PURE__*/_react.default.createElement(ScoreDescription, {
      viewport: viewport
    }, /*#__PURE__*/_react.default.createElement(_Text.default, {
      accessible: accessible,
      type: _constant2.DEFAULT_STYLE.SMALL,
      color: _constant2.DEFAULT_STYLE.TEXT_COLOR
    }, poorTag), /*#__PURE__*/_react.default.createElement(_Text.default, {
      accessible: accessible,
      type: _constant2.DEFAULT_STYLE.SMALL,
      color: _constant2.DEFAULT_STYLE.TEXT_COLOR
    }, excellentTag));
  };
  var getScoreColor = function getScoreColor(val) {
    if (val < _constant2.BIAS_RANGE.DETRACTORS) return _constant2.BIAS_COLORS.DETRACTORS;
    if (val < _constant2.BIAS_RANGE.NEUTRAL) return _constant2.BIAS_COLORS.NEUTRAL;
    return _constant2.BIAS_COLORS.PROMOTERS;
  };
  var getScoreArray = function getScoreArray(scoreRange) {
    return /*#__PURE__*/_react.default.createElement(ScoreLineWrapper, {
      tabIndex: tabIndex,
      viewport: viewport
    }, scoreRange.map(function (value) {
      return /*#__PURE__*/_react.default.createElement(SingleScoreBox, {
        tabIndex: tabIndex,
        isActive: ScoreSelected === value,
        id: "score-".concat(value),
        value: value,
        color: isScoringTypeBiased === 'TRUE' ? getScoreColor(value) : _constant2.DEFAULT_STYLE.UNBIASED_COLOR,
        getScore: getScore,
        scoreHeight: scoreHeight,
        scoreWidth: scoreWidth,
        scoreLineHeight: scoreLineHeight,
        borderColor: scoreColor
      });
    }));
  };
  var getDesktopView = function getDesktopView() {
    var scoreRange = [];
    for (var i = minScore; i <= maxScore; i += 1) {
      scoreRange = [].concat((0, _toConsumableArray2.default)(scoreRange), [i]);
    }
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, getScoreArray(scoreRange), getScoreDescription());
  };
  var getMobileView = function getMobileView() {
    var scoreRangeAbove = [];
    var scoreRangeBelow = [];
    for (var i = minScore; i <= maxScore; i += 1) {
      if (i < 6) scoreRangeAbove = [].concat((0, _toConsumableArray2.default)(scoreRangeAbove), [i]);else {
        scoreRangeBelow = [].concat((0, _toConsumableArray2.default)(scoreRangeBelow), [i]);
      }
    }
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, getScoreArray(scoreRangeAbove), getScoreArray(scoreRangeBelow), getScoreDescription());
  };
  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(ScoreBox, {
      tabIndex: tabIndex,
      marginBottom: marginBottom,
      maxWidth: viewport === _constant.DEVICE_TYPE.DESKTOP ? _constant2.DEFAULT_STYLE.MIN_WIDTH_DESKTOP : _constant2.DEFAULT_STYLE.MIN_WIDTH_MOBILE
    }, viewport === _constant.DEVICE_TYPE.DESKTOP ? getDesktopView() : getMobileView());
  };
  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};
Score.propTypes = _score.default.PropTypes;
Score.defaultProps = _score.default.DefaultProps;
var _default = Score;
exports.default = _default;